import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone } from 'ramda'
import moment from 'moment'
import { toast } from 'react-toastify'
import UnvalidatedReceiptsActions, {
  UnvalidatedReceiptsRedux,
  UnvalidatedReceiptsTypes,
} from '../Redux/UnvalidatedReceiptsRedux'

const unvalidatedReceiptsCrudObservable = createCRUDObservable({
  mainRedux: UnvalidatedReceiptsRedux,
  reduxPath: 'unvalidatedReceipts',
  dataHandlers: {
    get: response => response.data,
  },
})

const validateEpic = (action$, store, { Api }) =>
  action$.ofType(UnvalidatedReceiptsTypes.validateRequest)
    .mergeMap(({ id: receiptId }) => (
      Observable
        .fromPromise(Api.unvalidatedReceipts.validate(receiptId)
          .then(result => result)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [UnvalidatedReceiptsActions.validateFailure(response.error)]
          }

          const receipts = clone(store.getState().unvalidatedReceipts.get.results.data)
          const cardChangedIndex = receipts.findIndex(receipt => receipt.id === receiptId)
          receipts[cardChangedIndex].validated_at = moment().format('YYYY-MM-DD HH:mm:SS')

          return [
            UnvalidatedReceiptsActions.validateSuccess(receipts),
          ]
        })
    ))

const exportEpic = (action$, store, { Api }) =>
  action$.ofType(UnvalidatedReceiptsTypes.exportRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(
          Api.unvalidatedReceipts.export()
            .then(result => result)
            .catch(error => error)
        )
        .flatMap((response) => {
          const { status, data } = response

          // Manejo de errores
          if (!(status >= 200 && status < 300)) {
            let errorInfo = { status, message: 'Error al exportar' }
            
            if (response.code === 'ECONNABORTED') {
              errorInfo = { status: 'TIMEOUT', message: 'Timeout' }
            } else if (!status) {
              errorInfo = { status: 'NETWORK_ERROR', message: 'Network error' }
            } else if (status === 401) {
              errorInfo = { status: 401, message: 'Unauthorized' }
            } else if (status === 403) {
              errorInfo = { status: 403, message: 'Forbidden' }
            } else if (status === 500) {
              errorInfo = { status: 500, message: 'Server error' }
            }
            
            return [UnvalidatedReceiptsActions.exportFailure(errorInfo)]
          }

          // Éxito: Procesar descarga del archivo
          try {
            // Crear blob URL
            const blob = new Blob([data], { 
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
            })
            const url = window.URL.createObjectURL(blob)
            
            // Crear elemento <a> temporal
            const link = document.createElement('a')
            link.href = url
            link.download = 'Reporte_Recibos_SinValidar.xlsx'
            link.style.display = 'none'
            
            // Agregar al DOM, hacer clic, y remover
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            
            // Limpiar blob URL después de un breve delay
            setTimeout(() => {
              window.URL.revokeObjectURL(url)
            }, 100)
            
            // Mostrar notificación de éxito
            toast.success('Reporte exportado exitosamente', {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 3000,
            })
            
            return [UnvalidatedReceiptsActions.exportSuccess()]
          } catch (error) {
            return [UnvalidatedReceiptsActions.exportFailure({
              status: 'CLIENT_ERROR',
              message: 'Error al procesar el archivo descargado',
            })]
          }
        })
    ))
export const unvalidatedReceiptsObservers = Object.assign({},
  unvalidatedReceiptsCrudObservable.observers, {
  })

export const unvalidatedReceiptsEpic = combineEpics(
  unvalidatedReceiptsCrudObservable.epic,
  validateEpic,
  exportEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/UnvalidatedReceiptsObservable.js